(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-widget.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-widget.js');
"use strict";

setGlobal('svs.tickets.play.components.TicketWidget', () => {
  const name = 'ticketWidget';
  const widget = Handlebars.helpers.widgetArea({
    hash: {
      name
    }
  });
  return React.createElement("div", {
    className: "ticket-widget-container"
  }, widget ? React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: widget.string
    }
  }) : null);
});

 })(window);